import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackInitiateCheckout } from '../../utils/metaPixel';
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'lg';
  arrow?: boolean;
  href?: string;
  target?: '_blank';
  rel?: string;
  onClick?: () => void;
  ariaLabel?: string;
  trackCheckout?: boolean;
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'lg',
  arrow = false,
  href,
  target,
  rel,
  onClick,
  ariaLabel,
  trackCheckout = false
}: ButtonProps) {
  const styles = {
    primary: 'bg-cta text-cta-foreground shadow-lg shadow-cta/20 ring-1 ring-inset ring-black/10 transition-[background-color,transform] hover:bg-cta-hover active:scale-[0.98]',
    secondary: 'bg-surface text-foreground border border-primary/40 transition-[background-color,transform] hover:bg-surface-hover active:scale-[0.98]',
    outline: 'border-2 border-primary bg-transparent text-primary transition-colors hover:bg-surface'
  };
  const sizes = {
    sm: 'px-6 py-3.5 text-sm',
    lg: 'px-7 py-5 text-base sm:px-12 sm:py-6 sm:text-lg'
  };
  const classes = `inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl font-extrabold uppercase tracking-wide duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/50 ${styles[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return <a href={href} target={target} rel={rel} className={classes} aria-label={ariaLabel} onClick={() => {
      if (trackCheckout) trackInitiateCheckout();
      onClick?.();
    }} data-id="element-201" data-mp="12l8trs7abh9e">
        {children}
        {arrow && <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-202" data-mp="17ebs0dn0bevx" />}
      </a>;
  }
  return <button type="button" onClick={onClick} className={classes} aria-label={ariaLabel} data-id="element-203" data-mp="17go44a632v12">
      {children}
      {arrow && <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-204" data-mp="1hcrgs9ykac29" />}
    </button>;
}